// @flow
import * as React from 'react'
import styled from 'styled-components'
import ValueSizeReference from './value-size-reference'
import Value from './value'

const referenceTextSize = 10

const calculateProportion = (dimension: number, refDimension: number) => (referenceTextSize * dimension) / refDimension

type AutoResizableValueProps = ChannelsValueJsonConfig &
    ValueContent & {
        containerWidth: number,
        containerHeight: number
    }

type AutoResizableValueState = {
    width: number,
    height: number
}

export default class AutoResizableValue extends React.Component<AutoResizableValueProps, AutoResizableValueState> {

    state = {
        width: 0,
        height: 0
    }

    fitFontToHeightAndWidth = () => {
        if (this.state.width <= 0 || this.state.height <= 0) return 0

        const refTextWidth = this.state.width
        const refTextHeight = this.state.height
        const containerWidth = this.props.containerWidth
        const containerHeight = this.props.containerHeight

        const widthProportion = calculateProportion(containerWidth, refTextWidth)
        const heightProportion = calculateProportion(containerHeight, refTextHeight)

        return widthProportion > heightProportion ? heightProportion : widthProportion
    }

    fitFontToHeight = () => {
        if (this.state.width <= 0 || this.state.height <= 0) return 0

        const refTextHeight = this.state.height
        const containerHeight = (this.props.containerHeight * (this.props.maxHeight || 100)) / 100
        const heightProportion = calculateProportion(containerHeight, refTextHeight)

        return heightProportion
    }

    onChangeSize = (width: number, height: number) => {
        this.setState({
            width,
            height
        })
    }

    valueFontColor = () => {
        switch (this.props.valueFontColorOption) {
        case 'custom':
            return this.props.valueFontColor
        default:
            return undefined
        }
    }

    unitFontColor = () => {
        switch (this.props.unitFontColorOption) {
        case 'custom':
            return this.props.unitFontColor
        default:
            return undefined
        }
    }

    render () {
        const {
            value,
            uom,
            valueBold,
            unitBold,
            valueItalic,
            unitItalic,
            unitProportion,
            resizing,
            align
            /* backgroundColor, */
        } = this.props
        const calculateFontSize = resizing === 'fitToHeight' ? this.fitFontToHeight : this.fitFontToHeightAndWidth

        return (
            <Background backgroundColor={undefined /* backgroundColor */}>
                <Value
                    fontSize={calculateFontSize()}
                    valueFontColor={this.valueFontColor()}
                    unitFontColor={this.unitFontColor()}
                    align={align}
                    value={value}
                    valueBold={valueBold}
                    valueItalic={valueItalic}
                    unitBold={unitBold}
                    unitItalic={unitItalic}
                    unitProportion={unitProportion}
                    uom={uom}
                />
                <ValueSizeReference
                    value={value}
                    valueBold={valueBold}
                    valueItalic={valueItalic}
                    unitProportion={unitProportion}
                    unitBold={unitBold}
                    unitItalic={unitItalic}
                    uom={uom}
                    onChangeSize={this.onChangeSize}
                />
            </Background>
        )
    }

}

const Background = styled.div`
    background-color: ${props => props.backgroundColor};
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;
`
